import { MdArrowDropDown } from 'react-icons/md';
import React from 'react';
import Button from 'sinoui-components/Button';
import Icon from 'sinoui-components/Icon';
import { Subheading } from 'sinoui-components/Text';
// tslint:disable-next-line:no-any
function YearMonthSelect(props) {
    var modelState = props.modelState;
    var yearChecked = props.yearChecked;
    var monthChecked = props.monthChecked;
    return (React.createElement(Button, { onClick: props.onClickYearMonthSelect },
        React.createElement(Subheading, null, props.yearSelectButtonMessage),
        React.createElement(Icon, null,
            React.createElement(MdArrowDropDown, null))));
}
export default YearMonthSelect;
//# sourceMappingURL=YearMonthSelect.js.map